import { initializeCartCard } from "./cart-card";
import { initializeStorefrontModules } from "./storefront-modules";
import "./styles.css";
import "./styles.global.css";

const scriptUrl = new URL(
  (document.currentScript as HTMLScriptElement).src,
  location.href,
);

const params = new URLSearchParams(new URL(scriptUrl, location.href).search);

globalThis.redoWidgetId = params.get("widget_id")!;

// TODO: Get BGZ to update their script tag URLs so we can get rid of this
const widgetIds: Record<string, string> = {
  // cspell:disable
  "bodyguardz.com": "fcsuql0bisdah2r",
  "www.bodyguardz.com": "fcsuql0bisdah2r",
  "staging-na01-bodyguardz.demandware.net": "fcsuql0bisdah2r",
  "lander.com": "6429ss0d0wz08u1",
  "www.lander.com": "6429ss0d0wz08u1",
  "dev.citybeach.com": "qjr169lp5g3cg3w",
  "www.citybeach.com": "v6na2c54xpvpznc",
  "www.citybeach.com.au": "v6na2c54xpvpznc",
  // cspell:enable
};

const widgetId = params.get("widget_id") || widgetIds[location.hostname];

if (!widgetId) {
  throw new Error("Widget ID not found");
}

// cspell:disable-next-line
if (widgetId === "fcsuql0bisdah2r" || widgetId === "6429ss0d0wz08u1") {
  initializeCartCard({ widgetId });
} else {
  console.log("Initializing sfcc storefront modules...");
  initializeStorefrontModules();
}
